export const operationSystems = ['Windows', 'Mac'];

export const nodeConfig = {
  virtualNodeWidth: 66,
  nodeWidth: 240, // px
  nodeHeight: 68, // px
};

export const API_CALL_DEBOUNCE_TIME = 500;
export const DEFAULT_DEBOUNCE_TIME = 300;

export const ALL_RESOURCES_RESOURCE_GROUP_ID = '0c74f452-eee2-46df-8a5e-bd4816025833';
export const ALL_RESOURCES_RESOURCE_GROUP_LABEL = 'All machines';
